export default __webpack_public_path__ + "static/SR USA - Fiche de Données Sécurité - Caramel colorant (Liquide)-b396b31d15bc389caebd0b459478089e.pdf";